import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from 'src/app/app.settings';
import { ActivatedRoute } from '@angular/router';
import { Settings } from 'src/app/app.settings.model';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { Utils } from '../utils';
import { AppData } from 'src/app/app.data';
import { CustomerModel } from '../models/customer-model';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  settings: Settings;
  apiEndPoint: string = Utils.getApiEndPoint(); // environment.APIEndpoint;
  


  constructor(
    private http: HttpClient,
    private appSettings: AppSettings,
    private route: ActivatedRoute,
    private appData: AppData
  ) { 
    this.settings = appSettings.settings;
  }

  getDetails(customerID){
    return this.http.get<any>(this.apiEndPoint + `CustomerApi/GetCustomerDetails/${customerID}`)
    .pipe(map(result => {
      return result;
    }));
  }

  hasIDNumber(customerID: number){
    return this.http.get<any>(this.apiEndPoint + `CustomerApi/HasIDNumber/${customerID}`)
    .pipe(map(result => {
      return result;
    }));
  }

  

 /** update id number 
  * @param {customerID} number
  * @param {idNumber} string
  * @param {idType} number 1-TZ, 2-Passport, 3-Email, 99-GUID
 */
  updateIDNumber(customerID: number, idNumber:string, idType:number){

    const model = {
      CustomerID: customerID,
      Identity: idNumber,
      IdentityType: idType // 1-TZ, 2-Passport, 3=Email
    };

    return this.http.post<any>(this.apiEndPoint + `CustomerApi/UpdateIdNumber`, JSON.stringify(model))
    .pipe(map(result => {
      // this.loginModel = null;
      return result;
    }));
  }

  create(model: CustomerModel){
    return this.http.post<any>(this.apiEndPoint + `CustomerApi/Create`, JSON.stringify(model))
    .pipe(map(result => {
      // this.loginModel = null;
      return result;
    }));
  }


  
  /**
   * @typedef {object} UserBusinessesResponse
   * @property {number} Code - The response code
   * @property {object} Data - { shouldSelectBusiness: boolean, businessList: array of business }
   */

  /**
   * Returns the logged user businesses
   * @return {UserBusinessesResponse}
   *         The user business and flag if need to select business
   */
  getUserBusiness(){
    return this.http.get<any>(this.apiEndPoint + `CustomerApi/GetUserBusiness`)
    .pipe(map(result => {
      return result; 
    }));
  }

  getCustomerMetadata(businessID:number){
    return this.http.get<any>(this.apiEndPoint + `CustomerApi/GetCustomerMetadata/${businessID}`)
    .pipe(map(result => {
      return result; 
    }));
  }

  getCustomerBalance(customerID:number){
    return this.http.get<any>(this.apiEndPoint + `CustomerApi/GetCustomerBalance/${customerID}`)
    .pipe(map(result => {
      return result; 
    }));
  }

  loadCities(){
    return this.http.get<any>(this.apiEndPoint + `City`)
    .pipe(map(result => {
      return result; 
    }));
  }
}
